import { GOOGLE, LINKEDIN, META, TIKTOK } from "../../../utils/constants";

/** Colores de marca por plataforma (gráficos de comparación, pies, barras por red) */
export const GLOBAL_REPORT_PLATFORM_COLORS = {
  [META]: "#20242b",
  [GOOGLE]: "#4b5361",
  [TIKTOK]: "#828d9b",
  [LINKEDIN]: "#c3cad3",
};

const normalizePlatformKey = (platform) =>
  platform == null ? "" : String(platform).toLowerCase();

const PLATFORM_COLOR_BY_NORMALIZED_KEY = Object.entries(
  GLOBAL_REPORT_PLATFORM_COLORS
).reduce((acc, [platform, color]) => {
  acc[normalizePlatformKey(platform)] = color;
  return acc;
}, {});

export const getGlobalReportPlatformColor = (platform, fallbackIndex = 0) => {
  if (platform == null || platform === "") {
    return getGlobalReportPaletteColor(fallbackIndex);
  }

  const direct = GLOBAL_REPORT_PLATFORM_COLORS[platform];
  if (direct) return direct;

  const normalized =
    PLATFORM_COLOR_BY_NORMALIZED_KEY[normalizePlatformKey(platform)];
  if (normalized) return normalized;

  return getGlobalReportPaletteColor(fallbackIndex);
};

/** Paleta compartida para gráficos del Global Report */
export const GLOBAL_REPORT_CHART_PALETTE = [
  "#D6D3D1",
  "#232d3b",
  "#D6D3D1",
  "#292524",
  "#6366f1",
  "#14b8a6",
  "#f59e0b",
  "#8b5cf6",
  "#06b6d4",
  "#84cc16",
  "#f97316",
  "#3b82f6",
];

export const getGlobalReportPaletteColor = (index = 0) =>
  GLOBAL_REPORT_CHART_PALETTE[index % GLOBAL_REPORT_CHART_PALETTE.length];

/** Diagramas de barras del Global Report (creativos, diarios, plataforma fallback) */
export const GLOBAL_REPORT_BAR_COLOR = getGlobalReportPaletteColor(1);

/** @deprecated Usar GLOBAL_REPORT_BAR_COLOR */
export const GLOBAL_REPORT_CREATIVE_BAR_COLOR = GLOBAL_REPORT_BAR_COLOR;

/** Meta de resultados: completado (verde) y restante (gris de fondo) */
// export const GLOBAL_REPORT_GOAL_ACHIEVED_COLOR = "#1D9E75";
// export const GLOBAL_REPORT_GOAL_REMAINING_COLOR = "#94a3b8";
export const GLOBAL_REPORT_GOAL_ACHIEVED_COLOR = GLOBAL_REPORT_CHART_PALETTE[1];
export const GLOBAL_REPORT_GOAL_REMAINING_COLOR =
  GLOBAL_REPORT_CHART_PALETTE[0];

/** Proyección de resultados: real (oscuro) y forecast (gris) */
export const GLOBAL_REPORT_PROJECTION_ACTUAL_COLOR =
  getGlobalReportPaletteColor(1);
export const GLOBAL_REPORT_PROJECTION_FORECAST_COLOR =
  getGlobalReportPaletteColor(0);

export default GLOBAL_REPORT_CHART_PALETTE;
